import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { ReportService } from 'src/app/services/report.service';
import { SharedService } from 'src/app/services/sharedService';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css']
})
export class MainComponent implements OnInit {
  /**
   * This component will display specific stage of a specific report.
   * Year will not be shown in the path because it will be one of the report's property
   */
  stage = {}
  emittables = []
  reportId
  constructor(private route: ActivatedRoute, private reportService: ReportService, private sharedService: SharedService) {

  }

  ngOnInit() {

    this.route.paramMap.pipe(switchMap((params: ParamMap) => {
      this.reportId = params.get('reportId')
      return this.reportService.getReportPageNew(this.reportId, params.get('stageKey'))
    })).subscribe(async stagePage => {
      this.stage = stagePage
      this.emitStageValueKeys()
      this.emittables = await this.reportService.getValueEmittersPagesById(this.reportId).toPromise()
    })
  }

  printStage() {
  }
  emitStageValueKeys() {
    let stageValueKeys = []
    for (let block of this.stage['blocks']){
      for (let row of block['rows']){
        stageValueKeys.push(row.key)
        this.sharedService.setStageKeys(stageValueKeys)
      }
    }
  }
}
